/*
 * Password strength estimate (zxcvbn-ts with the Spanish dictionary). Loaded on
 * demand, only on screens that create a password: the dictionaries are large.
 * It only guides the user; the API decides (length, personal data, leaked lists).
 */
export interface Strength {
  score: 0 | 1 | 2 | 3 | 4;
  warning: string | null;
  suggestions: string[];
}

type Check = (password: string, userInputs: string[]) => Strength;

let loading: Promise<Check> | undefined;

export function loadStrengthChecker(): Promise<Check> {
  loading ??= (async () => {
    const [{ ZxcvbnFactory }, common, es] = await Promise.all([
      import('@zxcvbn-ts/core'),
      import('@zxcvbn-ts/language-common'),
      import('@zxcvbn-ts/language-es-es'),
    ]);
    const factory = new ZxcvbnFactory({
      translations: es.translations,
      graphs: common.adjacencyGraphs,
      dictionary: { ...common.dictionary, ...es.dictionary },
    });
    return (password, userInputs) => {
      const result = factory.check(password, userInputs);
      return {
        score: result.score,
        warning: result.feedback.warning,
        suggestions: result.feedback.suggestions,
      };
    };
  })();
  return loading;
}

export const STRENGTH_LABELS = ['Muy débil', 'Débil', 'Aceptable', 'Fuerte', 'Muy fuerte'] as const;
